// Accordion
let accordion = document.querySelector(".accordion");
let accBtns = accordion.querySelectorAll(".acc-btns a");
let accTexts = accordion.querySelectorAll(".acc-text");

accBtns.forEach((btn, index) => {
  btn.addEventListener("click", function (event) {
    event.preventDefault();

    // Toggle active class on buttons
    // accBtns.forEach((b) => b.classList.remove("active"));
    accBtns.forEach((btno, i) => {
      if (i === index) {
        btno.classList.add("active");
      } else {
        btno.classList.remove("active");
      }
    });


    // Show corresponding text and hide others
    accTexts.forEach((text, i) => {
      if (i === index) {
        text.classList.add("active");
      } else {
        text.classList.remove("active");
      }
    });
  });
});

let clearAccordions = function () {
  let accordion = document.querySelector(".accordion");
  let accBtns = accordion.querySelectorAll(".acc-btns a");
  let accTexts = accordion.querySelectorAll(".acc-text");

  accBtns.forEach((item, i) => {
    item.classList.remove("active");
    accTexts[i].classList.remove("active");
  });
};

let resetAccordions = function () {
  let accordion = document.querySelector(".accordion");
  let accBtns = accordion.querySelectorAll(".acc-btns a");
  let accTexts = accordion.querySelectorAll(".acc-text");

  accBtns.forEach((item, i) => {
    if (i === 0) {
      item.classList.add("active");
      accTexts[i].classList.add("active");
    } else {
      item.classList.remove("active");
      accTexts[i].classList.remove("active");
    }
  });
}

//Gallery
let galleryCon = document.querySelector(".gallery-container");
let gallerySwiper; // Declare a variable outside

if (galleryCon) {
  gallerySwiper = new Swiper(galleryCon, {
    //slidesPerView: 1,
    spaceBetween: 0,
    zoom: true,
    freeMode: false,
    loop: true,
    autoHeight: true,
    mouseWheel: {
      releaseOnEdges: true,
    },
    navigation: {
      nextEl: galleryCon.querySelector(".swiper-button-next"),
      prevEl: galleryCon.querySelector(".swiper-button-prev"),
    },
    pagination: {
      el: galleryCon.querySelector(".swiper-pagination"),
      clickable: true,
    },
    breakpoints: {
      500: {
        //slidesPerView: 2,
        freeMode: true,
        //autoHeight: false
      },
    },
  });
}

//Inventory Display + Variant Image Switch
let selectDrop = document.querySelector(".product-atc select");

if (selectDrop) {
  let quantityText = document.querySelectorAll(".information .quantity");
  let priceText = document.querySelectorAll(".information .price");
  let swiperSlides = document.querySelectorAll(
    ".gallery-container .swiper-slide",
  );
  let galleryImages = document.querySelectorAll(".desktop-gallery img");
  let masonryImages = document.querySelectorAll(".masonry .masonry-img");
  let masonryParent = document.querySelector(".masonry");

  let atcButton = document.querySelector(".product-atc button");

  selectDrop.addEventListener("change", function (event) {
    let selectedOption = event.target.selectedOptions[0];

    let name = selectedOption.getAttribute("data-title");
    let productId = selectedOption.getAttribute("data-product-id");
    let variantId = selectedOption.value;
    let img = selectedOption.getAttribute("data-img");
    let price = selectedOption.getAttribute("data-price");
    let formPrice = Shopify.formatMoney(price).replace(/\.00$/, "");

    // --- Inventory Text ---
    let inventory = selectedOption.getAttribute("data-inventory");


    if (inventory == 0) {
      setSourceButton();
      atcButton.setAttribute("type", "source");
      atcButton.innerHTML = "Sold Out";
      //atcButton.innerHTML = "Source For Me";
      //console.log(name, productId, variantId, img, formPrice);
      setSourceForm(name, productId, variantId, img, formPrice);
    } else if (inventory < 5) {
      atcButton.setAttribute("type", "submit");
      atcButton.innerHTML = "Add to Cart";
    } else {
      atcButton.innerHTML = "Add to Cart";
      atcButton.setAttribute("type", "submit");
    }

    quantityText.forEach((item) => {
      if (inventory == 0) {
        item.innerHTML = "Out of stock";
      } else if (inventory < 5) {
        item.innerHTML = inventory + " in stock";
      } else {
        item.innerHTML = "In stock";
      }
    });

    // --- Price Text ---
    //let price = selectedOption.getAttribute("data-price");

    priceText.forEach((item) => {
      let formattedPrice = Shopify.formatMoney(price).replace(/\.00$/, "");
      item.innerHTML = formattedPrice;
    });

    // --- Variant Image Switch for Desktop Gallery ---
    let selectedVariantId = selectedOption.value;
    let found = false;

    if(galleryImages.length == 0){
      galleryImages.forEach((img) => {
        const variantIds = img.dataset.variantIds
          ? img.dataset.variantIds.split(",")
          : [];

        if (variantIds.includes(selectedVariantId)) {
          found = true;
          img.classList.add("top");
        } else {
          img.classList.remove("top");
        }
      });
    }

    //Masonry Variant Image Switch
    if(masonryImages.length > 0){
      let defaultImg = masonryImages[0].src;
      masonryImages[0].src = img;
      masonryImages[0].setAttribute("srcset", img);
      masonryParent.classList.add('extend')
    }

    swiperSlides.forEach((slide, index) => {
      const variantIds = slide.dataset.variantIds
        ? slide.dataset.variantIds.split(",")
        : [];

      if (variantIds.includes(selectedVariantId)) {
        found = true;
        gallerySwiper.slideTo(index); // Replace 'swiper' if your Swiper instance has a different name
      }
    });

    //Optional fallback: if no variant image, go to the first slide
    if (!found && gallerySwiper) {
      gallerySwiper.slideToLoop(0);
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get("variant");

  if (variantId) {
    const select = document.querySelector(".variant-select");
    if (select === null) return;
    const option = select.querySelector(`option[value="${variantId}"]`);

    console.log(option);

    if (option) {
      option.selected = true;
      const event = new Event("change", { bubbles: true });
      select.dispatchEvent(event);
    }
  }
});

let zoomBtn = document.querySelectorAll(".zoom-btn");

zoomBtn.forEach((item) => {
  item.addEventListener("click", function (event) {
    event.preventDefault();

    document.body.classList.toggle("zoom");

    item.scrollIntoView({
      //behavior: "smooth",
      block: "start",
    });
  });
});

//Source Button
let setSourceButton = function(){
  let pdpButton = document.querySelectorAll(".product-atc .pdp-atc-btn");
  pdpButton.forEach((btn) => {
    btn.addEventListener("click", function (event) {
      if (btn.getAttribute("type") === "source") {
        event.preventDefault();
        //document.querySelector("#side-source").classList.add("active");
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  let singleSourceButton = document.querySelector(".single-pdp-atc-btn");

  if (singleSourceButton) {
    let name = singleSourceButton.getAttribute("data-title");
    let productId = singleSourceButton.getAttribute("data-product-id");
    let variantId = singleSourceButton.getAttribute("data-variant-id");
    let img = singleSourceButton.getAttribute("data-img");
    let price = singleSourceButton.getAttribute("data-price");
    let formPrice = Shopify.formatMoney(price).replace(/\.00$/, "");

    setSourceForm(name, productId, variantId, img, formPrice);

    singleSourceButton.addEventListener("click", function (event) {
      event.preventDefault();
      //document.querySelector("#side-source").classList.add("active");
    });
  }
});